

export const mensShoesPage1 = [
  {
    image: "https://example.com/shoe1.jpg",
    brand: "Nike",
    title: "Air Max 270",
    color: "Black",
    selling_price: "₨ 8,999",
    price: "₨ 10,999",
    disscount: "18% off",
    size: "42",
  },
  {
    image: "https://example.com/shoe2.jpg",
    brand: "Adidas",
    title: "UltraBoost",
    color: "White",
    selling_price: "₨ 12,499",
    price: "₨ 14,999",
    disscount: "17% off",
    size: "43",
  },
  {
    image: "https://example.com/shoe3.jpg",
    brand: "Puma",
    title: "RS-X",
    color: "Red",
    selling_price: "₨ 7,999",
    price: "₨ 9,999",
    disscount: "20% off",
    size: "41",
  },
  {
    image: "https://example.com/shoe4.jpg",
    brand: "Reebok",
    title: "Classic Leather",
    color: "Blue",
    selling_price: "₨ 6,499",
    price: "₨ 7,999",
    disscount: "19% off",
    size: "44",
  },
  {
    image: "https://example.com/shoe5.jpg",
    brand: "Asics",
    title: "Gel-Kayano",
    color: "Green",
    selling_price: "₨ 11,999",
    price: "₨ 13,999",
    disscount: "14% off",
    size: "40",
  },
];